<template>
    <div>
        <v-layout row wrap>
            <v-flex lg12>
                    <v-card>
                        <v-card-text class="pa-0">
                            <v-data-table
                                    :items="results.hits"
                                    :total-items="results.total"
                                    :pagination.sync="pagination"
                                    :rows-per-page-items="[5,10,15,20,25,30,40,50]"
                                    :loading="loading"
                                    class="elevation-1"
                                    item-key="_id"
                            >
                                <template slot="headers" slot-scope="props">
                                    <tr>
                                        <th v-if="!adaptive || !hideColumn('make')" class="text-xs-left">{{$t('message.177')}}</th>
                                        <th v-if="!adaptive || !hideColumn('model')" class="text-xs-left">{{$t('message.174')}}</th>
                                        <th v-if="!adaptive || !hideColumn('capacity')" class="text-xs-left">{{$t('message.258')}}</th>
                                        <th v-if="!adaptive || !hideColumn('fuel')" class="text-xs-left">{{$t('message.203')}}</th>
                                        <th class="text-xs-left">Start</th>
                                        <th class="text-xs-left">End</th>
                                        <th v-if="hideColumn('fuel')" class="text-xs-left">{{$t('message.146')}}</th>
                                        <th v-if="hideColumn('fuel')" class="text-xs-left">{{$t('message.130')}}</th>
                                        <th v-if="hideColumn('fuel')" class="text-xs-left">{{$t('message.204')}}</th>
                                        <th v-if="!adaptive || hideColumn('fuel')" class="text-xs-left">{{$t('message.115')}}</th>
                                        <th v-if="!adaptive || !hideColumn('body')" class="text-xs-left">{{$t('message.265')}}</th>
                                        <th class="text-xs-left">{{$t('message.150')}}</th>
                                        <th v-if="$auth.check() && $auth.user().showStock" class="text-xs-left">Stock GB / NL</th>
                                        <th v-if="$auth.check() && $auth.user().showPrices" class="text-xs-left">Price</th>
                                        <th class="text-xs-left">{{$t('message.114')}}</th>
                                        <th class="text-xs-left" v-if="hideColumn('capacity')">{{$t('message.109')}}</th>
                                        <th class="text-xs-left" v-if="hideColumn('fuel')">Engines</th>
                                        <th class="text-xs-left" v-if="hideColumn('fuel')">KW</th>
                                        <th class="text-xs-left" v-if="hideColumn('fuel')">HP</th>
                                        <th class="text-xs-left" v-if="hideColumn('fuel')">ABS</th>
                                        <th class="text-xs-left" v-if="!adaptive || hideColumn('fuel')">{{$t('message.230')}}</th>
                                    </tr>
                                </template>
                                <template slot="items" slot-scope="props">
                                    <td v-if="!adaptive || !hideColumn('make')">{{ props.item.make }}</td>
                                    <td v-if="!adaptive || !hideColumn('model')" >{{ props.item.model }}</td>
                                    <td v-if="!adaptive || !hideColumn('capacity')" >{{ props.item.capacity }}</td>
                                    <td v-if="!adaptive || !hideColumn('fuel')">{{ localiseFuel(props.item.fuel) }}</td>
                                    <td>{{ props.item.year_start }}</td>
                                    <td>{{ props.item.year_end }}</td>
                                    <td v-if="hideColumn('fuel')">{{ localisePosition(props.item.position) }}</td>
                                    <td v-if="hideColumn('fuel')">{{ localiseSide(props.item.side) }}</td>
                                    <td v-if="hideColumn('fuel')">{{ localiseFrontRear(props.item.front_rear) }}</td>
                                    <td v-if="!adaptive || hideColumn('fuel')">{{localiseTransmission(props.item.transmission) }}</td>
                                    <td v-if="!adaptive || !hideColumn('body')">{{ props.item.body }}</td>
                                    <td>
                                        <template v-if="linkToParts">
                                            <v-btn small icon flat @click="showPart(props.item.part)" title="View Part"><v-icon>search</v-icon></v-btn>{{ props.item.part }}
                                        </template>
                                        <template v-else>
                                            {{ props.item.part }}
                                        </template>
                                        <v-badge v-if="$auth.check()" overlap color="red" class="mr-3">
                                            <span v-if="getPartCount(props.item.part)" slot="badge" small>{{getPartCount(props.item.part)}}</span>
                                            <v-icon title="Add to Cart" color="green" @click="addToCart(props.item, getPartCount(props.item.part))">shopping_cart</v-icon>
                                        </v-badge>
                                        <v-icon v-if="props.item.is_image_available" title="View Part Image" color="primary" @click="showImage(props.item.part)">image</v-icon>
                                        <v-icon v-if="props.item.note" title="View Note" color="primary" @click="showNote(props.item.part, props.item.note)">notes</v-icon>
                                    </td>
                                    <td v-if="$auth.check() && $auth.user().showStock">{{ props.item.stock_gb }} / {{ props.item.stock_nl }}</td>
                                    <td v-if="$auth.check() && $auth.user().showPrices">
                                        <span v-if="props.item.price">{{props.item.symbol}} {{props.item.price | currency}}</span>
                                    </td>
                                    <td>{{ localisePartType(props.item.part_type) }}</td>
                                    <td v-if="hideColumn('capacity')">{{ (props.item.vin) ? props.item.vin.join(', ') : null }}</td>
                                    <td v-if="hideColumn('fuel')">{{ (props.item.engines) ? props.item.engines.join(', ') : null }}</td>
                                    <td v-if="hideColumn('fuel')">{{ props.item.kw }}</td>
                                    <td v-if="hideColumn('fuel')">{{ props.item.hp }}</td>
                                    <td v-if="hideColumn('fuel')">{{ props.item.abs }}</td>
                                    <td v-if="!adaptive || hideColumn('fuel')">{{ props.item.detail }}</td>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
        </v-layout>
        <image-dialog ref="imageDialog"></image-dialog>
        <note-dialog ref="noteDialog"></note-dialog>
        <add-quote-dialog ref="addQuoteDialog"></add-quote-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ResultsWidget',
  props: {
    index: String,
    adaptive: Boolean,
    linkToParts: Boolean
  },
  data () {
    return {
      query: null,
      loading: false,
      pagination: { page: 1, totalItems: 0, rowsPerPage: 10, sortBy: '', descending: false },
      results: {},
      filters: null
    }
  },
  created () {
    this.filters = new Set()
  },
  mounted () {
    this.$events.listen('filterEvent', filters => {
      this.$log.debug('Filter Event')
      this.$log.debug(filters)
      this.filters = new Set(filters)
      this.internalSearch()
    })
  },
  computed: {
    ...mapGetters(
      'quote', {
        partCount: 'partCount'
      }),
    ...mapGetters(
      'filters', {
        globalFilters: 'globalFilters'
      })
  },
  methods: {
    search (value) {
      this.$log.debug(`Results Widget Search query:${value}`)
      this.query = value
      this.filters = new Set()
      if (value) {
        this.internalSearch()
      } else {
        this.results = {}
        this.$events.$emit('searchEvent', null)
      }
    },
    searchRaw (value) {
      this.$log.debug(`Results Widget Search Raw query:${value}`)
    },
    internalSearch () {
      this.loading = true
      this.axios.get(this.index, {
        params: {
          query: this.query,
          filter: Array.from(this.filters),
          global_filter: this.globalFilters,
          page: this.pagination.page,
          size: this.pagination.rowsPerPage,
          sort: this.pagination.sortBy,
          desc: this.pagination.descending
        },
        paramsSerializer: (params) => this.$qs.stringify(params, { arrayFormat: 'repeat' })
      })
        .then(response => {
          this.$log.debug(`API call to ${this.index} OK`)
          this.results = response.data.data
          this.$log.debug(`Number of hits: ${this.results.total}`)
          this.$events.$emit('searchEvent', this.results || null)
        })
        .catch(e => {
          this.$log.error(e)
        }).finally(() => {
          this.loading = false
        })
    },
    addToCart (item, quantity) {
      this.$refs.addQuoteDialog.show({ isNew: true, item: item, quantity: quantity || 1 })
    },
    showPart (part) {
      this.$router.push({ name: 'part', query: { part: part } })
    },
    showImage (part) {
      this.$refs.imageDialog.show(part)
    },
    showNote (part, note) {
      this.$refs.noteDialog.show(part, note)
    },
    hideColumn (column) {
      if (!this.adaptive || !this.query) {
        return false
      }
      return this.query.includes(`${column}:`)
    },
    localiseFuel (value) {
      let mapping = {
        'P': this.$t('message.1'),
        'D': this.$t('message.2'),
        'E': this.$t('message.26')
      }
      return mapping[value]
    },
    localisePosition (value) {
      let mapping = {
        '': '',
        'O': this.$t('message.6'),
        'I': this.$t('message.7'),
        'B': this.$t('message.8')
      }
      return mapping[value]
    },
    localiseSide (value) {
      let mapping = {
        '': '',
        'B': this.$t('message.8'),
        'L': this.$t('message.9'),
        'R': this.$t('message.10')
      }
      return mapping[value]
    },
    localiseFrontRear (value) {
      let mapping = {
        '': '',
        'B': this.$t('message.30'),
        'F': this.$t('message.11'),
        'R': this.$t('message.12')
      }
      return mapping[value]
    },
    localiseTransmission (value) {
      let mapping = {
        '': '',
        'MTM+ATM': this.$t('message.5'),
        'MTM': this.$t('message.3'),
        'ATM': this.$t('message.4')
      }
      return mapping[value]
    },
    localisePartType (value) {
      let mapping = {
        'DS': this.$t('message.13'),
        'ABS': this.$t('message.24'),
        'OJT': this.$t('message.14'),
        'IJT': this.$t('message.15'),
        'BT': this.$t('message.23'),
        'SN': this.$t('message.27'),
        'ALBS': this.$t('message.25'),
        'ADP': this.$t('message.17'),
        'PJT': this.$t('message.19'),
        'PROP': this.$t('message.18'),
        'PBT': this.$t('message.20'),
        // TODO: Ian to supply this 'BR': this.$t('message.5'),
        'IJTK': this.$t('message.7'),
        'DSK': this.$t('message.29'),
        'WBHS': this.$t('message.31')
      }
      return mapping[value]
    },
    getPartCount (part) {
      return this.partCount(part)
    }
  },
  watch: {
    pagination: {
      handler () {
        this.$log.debug(`Pagination changed: ${this.pagination}`)
        this.$log.debug(`Pagination Page: ${this.pagination.page}`)
        if (!this.isLoading) {
          this.internalSearch()
        } else {
          this.$log.debug(`Pagination blocked`)
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>

</style>
